(function () {
  'use strict';

  function init(scope) {
    (scope || document).querySelectorAll('[data-gd-showcase-autoplay]').forEach(function (track) {
      if (track.dataset.gdShowcaseAutoplayBound) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.gd-showcase__card'));
      var bar = track.parentElement && track.parentElement.querySelector('[data-gd-showcase-autoplay-bar] span');
      if (cards.length < 2 || !bar) return;
      track.dataset.gdShowcaseAutoplayBound = 'true';
      var interval = Math.max(3000, Number(track.dataset.gdShowcaseInterval || 4000));
      var current = 0;
      var timer = 0;

      function restartBar() {
        bar.classList.remove('is-running');
        bar.style.animationDuration = interval + 'ms';
        void bar.offsetWidth;
        bar.classList.add('is-running');
      }

      function schedule() {
        window.clearTimeout(timer);
        restartBar();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setTimeout(function () {
          current = (current + 1) % cards.length;
          track.scrollTo({ left: cards[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          schedule();
        }, interval);
      }

      function syncCurrent() {
        var nearest = 0;
        var distance = Infinity;
        cards.forEach(function (card, index) {
          var cardDistance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (cardDistance < distance) {
            distance = cardDistance;
            nearest = index;
          }
        });
        if (nearest !== current) {
          current = nearest;
          schedule();
        }
      }

      track.addEventListener('scroll', syncCurrent, { passive: true });
      track.addEventListener('pointerdown', schedule, { passive: true });
      track.addEventListener('touchstart', schedule, { passive: true });
      schedule();
    });
    (scope || document).querySelectorAll('.gd-routine-mosaic video').forEach(function (video) {
      if (video.dataset.gdRoutineVideoBound) return;
      video.dataset.gdRoutineVideoBound = 'true';
      if (!('IntersectionObserver' in window)) {
        video.play().catch(function () {});
        return;
      }
      var visible = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function syncPlayback() {
        if (visible && !document.hidden && !reducedMotion.matches) {
          if (video.paused) video.play().catch(function () {});
        } else {
          video.pause();
        }
      }
      var observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        syncPlayback();
      }, { threshold: 0.25 });
      observer.observe(video);
      document.addEventListener('visibilitychange', syncPlayback);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());